import axios from 'axios';
import { serverConfig } from './server-config';
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);
export const CandidatePreLoginService = {
  candidateRegistration: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/candidate/pre-login/register`;

    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error during registering:", error);
        throw error;
      });
  },

};
